import { useContext, useEffect, useState } from "react";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";
import { showToast } from "../../../../helpers/ToastifyHelper";
import { Form, Formik } from "formik";
import { FormControl, InputLabel, MenuItem, Select, TextField, CircularProgress } from "@mui/material";
import SearchComponent from "../../../../components/OB/SearchComponent";
import TableComponent2 from "../../../../components/OB/TableComponent2";
import CaddeSokakAPI from "../../../../apis/OB/Get/CaddeSokakAPI";
import ExportPdfAPI from "../../../../apis/OB/Rapor/ExportPdfAPI";
import { openFileInNewTab } from "../../../../helpers/openFileNewTab";
import { today } from "../../../../helpers/TodayDate";
import EmlakBorcKontrolAPI from "../../../../apis/OB/Get/EmlakBorcKontrolAPI";
import RayicExportPdfAPI, { IEnRayicRequest } from "../../../../apis/OB/Rapor/RayicExportPdfAPI";
import SessionStorageService from "../../../../services/StorageService";
import EmlakBildirimAPI from "../../../../apis/OB/Get/EmlakBildirimAPI";

const EmlakBildirim = (props: any) => {
    // Borç Kontrol ve Beyan Sureti İşlemi Pdf
    const exportRayicSuret = (sqId: string) => {
        let enRequest: IEnRayicRequest = {
            sqId: sqId,
        };
        RayicExportPdfAPI.geExportPdfListe(enRequest)
            .then((res) => {
                if (res.data !== null) {
                    openFileInNewTab(
                        res.data.reportUrlByteFormat,
                        "-Tapu Rayiç Sureti - " + today + ".pdf"
                    );
                } else {
                    showToast("Pdf indirilirken bir sorun oluştu", "error")
                }
            })
            .catch((err) => {
                showToast("İşleminizi şu anda gerçekleştiremiyoruz", "error")
            });
    };
    const getSuretPdf = (sqId: string, beyanTuru: string) => {
        ExportPdfAPI.geExportPdfListe(sqId, beyanTuru)
            .then((res) => {
                if (res.data !== null) {
                    openFileInNewTab(
                        res.data.reportUrlByteFormat,
                        "-Emlak Sureti - " + today + ".pdf"
                    );
                } else {
                    showToast("Pdf indirilirken bir sorun oluştu", "error")
                }
            })
            .catch((err) => {
                showToast("Pdf indirilirken bir sorun oluştu", "error")
            });
    };
    const getTypeSuretPdf = (sqId: string, turu: string) => {
        switch (turu) {
            case "BINA":
                getSuretPdf(sqId, "1");
                break;
            case "ARSA":
                getSuretPdf(sqId, "2");
                break;
            case "ARAZİ":
                getSuretPdf(sqId, "3");
                break;
        }
    };

    const borcKontrol = (sqId: number, durum: number, turu?: string) => {
        if (turu == "") {
            showToast("İşleminizi şu anda gerçekleştiremiyoruz", "error")
            return;
        }
        EmlakBorcKontrolAPI.getEmlakBorcKontrol(sqId, durum)
            .then((res) => {
                switch (durum) {
                    case 1:
                        if (res.data[0].sonuc == 1) {
                            showToast("Borç kaydınız bulunmamaktadır", "info");
                        } else {
                            if (turu !== undefined) {
                                getTypeSuretPdf(sqId.toString(), turu);
                            }
                        }
                        break;
                    case 2:
                        res.data[0].sonuc == 1
                            ? showToast("Borç kaydınız bulunmamaktadır", "info")
                            : exportRayicSuret(sqId.toString());
                        break;
                }
            })
            .catch((err) => {
                showToast("İşleminizi şu anda gerçekleştiremiyoruz", "error");
            });
    };

    const columns = [
        { header: "", field: "", className: "text-center", classNameDiv: "d-flex align-self-stretch flex-column flex-md-row justify-content-evenly gap-2 gap-md-1", beyan: 3 },
        { header: "Türü", field: "turu", className: "text-center" },
        { header: "Adres", field: "adres", className: "text-center" },
        { header: "Pafta/Ada/Parsel", field: "paftaAdaParsel", className: "text-center" },
        { header: "İnşaat Bitim Tarihi", field: "insaatBitimTarihi", className: "text-center" },
        { header: "İktisap Tarihi", field: "iktisapTarihi", className: "text-center" },
        { header: "Arsa Alanı", field: "arsaAlani", className: "text-center" },
        { header: "A. Hisse Oran", field: "aHisseOran", className: "text-center" },
        { header: "Bina Alanı", field: "binaAlani", className: "text-center" },
        { header: "B. Hisse Oran", field: "bHisseOran", className: "text-center" },
        { header: "Rayiç", field: "rayic", className: "text-center" },
        { header: "Satış Tarihi", field: "satisTarihi", className: "text-center" },
        { header: "Tapu Cilt Syf.", field: "tapuCiltSyf", className: "text-center" },
        { header: "K. Sıra No", field: "kSiraNo", className: "text-center" },
        { header: "Açıklama", field: "aciklama", className: "text-center" },
    ];

    const [data, setData] = useState<any[]>([]);
    const [searchControl, setSearchControl] = useState<boolean>(true);
    const { mahalleListe } = useContext(ConstantAPISContext);
    const [selectedYear, setSelectedYear] = useState(Number(new Date().getFullYear()));
    const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<any>();
    const [selectedCaddeSokakKodu, setSelectedCaddeSokakKodu] = useState<any>(undefined);
    const [caddeSokakDatas, setCaddeSokakDatas] = useState<any[]>([]);
    const [aktifPasif, setAktifPasif] = useState<number>(1);
    const [ada, setAda] = useState<any>(undefined);
    const [parsel, setParsel] = useState<any>(undefined);
    const [isLoading, setisLoading] = useState<boolean>(false);

    //CaddeSokakAPI
    useEffect(() => {
        if (selectedMahalleKodu !== undefined && !Number.isNaN(selectedMahalleKodu)) {
            CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
                .then((res) => {
                    setCaddeSokakDatas(res.data);
                })
                .catch((err) => {
                });
        }
    }, [selectedMahalleKodu]);

    let user = SessionStorageService.getUserInfo();

    //EmlakBildirimAPI
    useEffect(() => {
        if (user) {
            fetchData(false);
        }
    }, []);

    const fetchData = async (isPass: boolean = true) => {
        setisLoading(true);
        const response = await EmlakBildirimAPI.getEmlakBildirimListe(
            user?.sicilKodu,
            aktifPasif,
            ada || null,
            parsel || null,
            selectedMahalleKodu || null,
            selectedCaddeSokakKodu || null,
        );
        setData(response.data);
        setTimeout(() => {
            setisLoading(false);

        }, 100)
        setSearchControl(true);
        if (response.data.length < 1)
            showToast("Kayıt Bulunamadı!", "warning");
    };

    const handleTemizle = () => {
        setSelectedYear(Number(new Date().getFullYear()));
        setSelectedCaddeSokakKodu(undefined);
        setSelectedMahalleKodu(undefined);
        setAktifPasif(1);
        setAda(undefined);
        setParsel(undefined);
    };

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={() => { }}>
                <Form id="kayit-form" className="d-flex w-100 mb-4">
                    <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                        <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id=""></InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    label=""
                                    value={aktifPasif || ""}
                                    onChange={(e) => {
                                        setAktifPasif(Number(e.target.value));
                                    }}
                                >
                                    <MenuItem selected value={1}>{"Aktif"}</MenuItem>
                                    <MenuItem value={2}>{"Pasif"}</MenuItem>
                                    <MenuItem value={3}>{"Hepsi"}</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id="">Mahalle</InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    error={selectedMahalleKodu == undefined && searchControl == false ? true : false}
                                    value={selectedMahalleKodu || ""}
                                    label="Mahalle"
                                    onChange={(e) => {
                                        setSelectedMahalleKodu(Number(e.target.value || undefined));
                                        setSelectedCaddeSokakKodu(undefined);
                                    }}
                                >
                                    {mahalleListe.map((item) => (
                                        <MenuItem
                                            key={item}
                                            value={item.mahalleKodu}>
                                            {item.mahalleAdi}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id="">Cadde/Sokak</InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    value={selectedCaddeSokakKodu || ""}
                                    label="Cadde/Sokak"
                                    onChange={(e) => {
                                        setSelectedCaddeSokakKodu(Number(e.target.value || undefined));
                                    }}
                                >
                                    {caddeSokakDatas.map((item) => (
                                        <MenuItem
                                            key={item}
                                            value={item.caddeSokakKodu}>
                                            {item.caddeSokakAdi}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <TextField id="" label="Ada" variant="outlined" size="small"
                                    value={ada || ""}
                                    onChange={(event) => event.target.value === "" ? setAda("") : event.target.value.match(/^[0-9]+$/) ? setAda(event.target.value.substring(0, 10)) : null}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <TextField id="" label="Parsel" variant="outlined" size="small"
                                    value={parsel || ""}
                                    onChange={(event) => event.target.value === "" ? setParsel("") : event.target.value.match(/^[0-9]+$/) ? setParsel(event.target.value.substring(0, 10)) : null}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                        },
                                    }}
                                />
                            </FormControl>
                        </div>
                        <div className="d-flex  flex-row ms-auto ">
                            <SearchComponent
                                fetchData={fetchData}
                                onTemizle={handleTemizle}
                                setData={setData} />
                        </div>
                    </div>
                </Form>
            </Formik>
            {isLoading ?
                <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                    <CircularProgress />
                </div>
                :
                <TableComponent2 columns={columns} data={data} recordsPerPage={7} borcKontrol={borcKontrol}></TableComponent2>
            }
        </>
    );
}

export default EmlakBildirim;
